export default defineNuxtRouteMiddleware(async (to, from) => {
  try {
    const errorStore = useErrorStore()
    const pageStore = usePageStore()
    const { setUaO } = useUserStore()
    const { merge } = useDataStore()
    const { getPageByPath } = usePage()
    const quickLinkStore = useQuickLinkStore()
    const { addPageViewEvent } = useLogStore()

    const isManagement = (targetPath: string) => {
      return targetPath.startsWith('/management') || targetPath.startsWith('/en/management')
    }
    const isWebParts = (targetPath: string) => {
      return targetPath.startsWith('/webparts') || targetPath.startsWith('/en/webparts')
    }

    if (from?.fullPath) {
      //  VueRouterに遷移元のURLを強制的に設定するように対応
      ;(to as any).prevFullPath = from.fullPath
    }

    // エラー情報のクリア
    errorStore.clearTemp()
    // クイックリンク情報のクリア
    quickLinkStore.clearQuickLink()

    // ------------------------------------------------------------
    //  dap_pageの設定に伴う、ナビゲーション制御(画面毎の参照権限)
    // ------------------------------------------------------------

    if (pageStore.current?.path !== to.path) {
      const pageAndCache = await getPageByPath(to)
      const page = pageAndCache.page
      const cache = pageAndCache.cache
      const uao = pageAndCache.uao
      setUaO(uao)
      merge(cache)

      if (isManagement(to.path)) {
        if (uao?.user == null) {
          // 管理画面へのアクセスで、未ログインの場合は、強制的にログイン画面リダイレクトする
          // tokenをクエリパラメータとして持つ場合はサインインページに引き継ぐ
          const {token} = to.query
          const tokenStr = Array.isArray(token) ? token[0] : token
          if(tokenStr){
            return navigateTo(`/signin?token=${tokenStr}`, {
              redirectCode: 302,
            })
          }
          return navigateTo('/signin', {
            redirectCode: 302,
          })
        } else if (to.meta.sysad && uao?.role !== 'SYSTEM_ADMIN') {
          // sysad権限が無い人がsysad専用ページに遷移するのは阻止する
          return navigateTo('/', {
            redirectCode: 302,
          })
        }
      }

      // 200以外の応答の場合、ResponseStatusを設定する
      if (page.error) {

        // リダイレクト対象であればリダイレクトする
        if (import.meta.server) {
          let isRedirect = false
          let targetPath = to.path
          if (dapRedirect.hasOwnProperty(targetPath)) {
            isRedirect = true
          } else if (targetPath.endsWith('/')) {
            targetPath = targetPath.slice(0, -1)
            if (dapRedirect.hasOwnProperty(targetPath)) {
              isRedirect = true
            }
          } else {
            targetPath = targetPath + '/'
            if (dapRedirect.hasOwnProperty(targetPath)) {
              isRedirect = true
            }
          }
          if (isRedirect) {
            return navigateTo(cnvParamPath(dapRedirect[targetPath], to.query), {
              redirectCode: 302,
            })
          }
        }

        // webpartsの場合はページ情報なくて正しいので、webparts以外の場合をエラーとする
        if (!isWebParts(to.path)) {
          errorStore.setDapError(
            page.error?.code,
            pageStore.current?.path,
            to.path
          )
        }
      }

      // ここで直接setPageすると、それを見てパンクズを生成している部分などが動作してしまうので、ここでは一時的に設定する。usePageで入れ替えを行う
      pageStore.setCurrentPage(page)
    }

    if (errorStore.hasCurrentError()) {
      return showError(errorStore.createDapError())
    } else if (import.meta.client && !isManagement(to.path) && !isWebParts(to.path)) {
      try {
        //  pvの統計情報登録
        addPageViewEvent(to.fullPath)
      } catch (e) {
        console.error('stats error', e)
      }
    }
  } catch (e) {
    console.error('navigation.global error', e)
  }
})
